// Who operates this site.
//
// Build Bots Now is a Nebulon Labs product, the same as Stock Picks Now and
// GameLinePicks, and the legal entity and postal address are identical across
// all three. On this site they are shown only on the Terms and Privacy pages;
// they live here so that if the address ever changes there is exactly one line
// to edit.

export const PRODUCT_NAME = "Build Bots Now";

export const PRODUCT_TAGLINE = "Chat assistants that answer from your own content.";

export const COMPANY_LEGAL_NAME = "Nebulon Labs LLC";
export const COMPANY_SHORT_NAME = "Nebulon Labs";
export const COMPANY_URL = "https://nebulonlabs.com";
export const COMPANY_ADDRESS = "14707 S Dixie Hwy, Suite 402C #182, Palmetto Bay, FL 33176";

export const SUPPORT_EMAIL = "hello@nebulonlabs.com";
export const PRIVACY_EMAIL = "privacy@nebulonlabs.com";

// The product's own inbox (it also gets our model and usage alerts), for
// anything a customer asks about the product itself, Enterprise included.
export const PRODUCT_EMAIL = "hello@buildbotsnow.com";

// Rendered rather than hard-coded: a footer that says 2026 in 2028 is the
// smallest possible signal that nobody is home.
export function copyrightYear(now: Date = new Date()): number {
  return now.getFullYear();
}
